"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACDatePickerElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_js_1 = __importDefault(require("dayjs/plugin/customParseFormat.js"));
var react_1 = require("react");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
dayjs_1.default.extend(customParseFormat_js_1.default);
var ACDatePickerElement = function (props) {
    var _a = (0, react_1.useState)(null), dateState = _a[0], setDateState = _a[1];
    (0, react_1.useEffect)(function () {
        // const inputFormat = props.isDateTime
        //   ? 'DD-MM-YYYY HH:mm'
        //   : props.format || 'DD-MM-YYYY';
        if (props.value === '') {
            setDateState(null);
        }
        else if (props.value) {
            var possibleFormats = props.isDateTime
                ? ['DD-MM-YYYY HH:mm', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm']
                : ['DD-MM-YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY'];
            var parsedDate = (0, dayjs_1.default)(props.value, possibleFormats, false);
            setDateState(parsedDate.isValid() ? parsedDate : null);
        }
    }, [props.value, props.isDateTime, props.format]);
    var handleChange = function (date) {
        setDateState(date);
        var outputFormat = props.isDateTime
            ? props.format || 'DD-MM-YYYY HH:mm'
            : props.format || 'DD-MM-YYYY';
        var formatted = date && date.isValid() ? date.format(outputFormat) : '';
        if (props.onChange) {
            props.onChange(formatted);
        }
    };
    var disabledDate = function (current) {
        if (props.enabledDates === 'enable_all') {
            return false;
        }
        if (props.enabledDates === 'one_month') {
            var today = (0, dayjs_1.default)().startOf('day');
            var oneMonthLater = today.add(30, 'day').endOf('day');
            return current && (current < today || current > oneMonthLater);
        }
        if (props.enabledDates === 'from_today') {
            return current && current < (0, dayjs_1.default)().startOf('day');
        }
        return current && current > (0, dayjs_1.default)().endOf('day');
    };
    var disabledTime = function (current) {
        if (!current)
            return {};
        if (props.enabledDates === 'enable_all') {
            return {};
        }
        if (props.enabledDates === 'from_today') {
            if (current.isSame((0, dayjs_1.default)(), 'day')) {
                var hours_1 = Array.from({ length: 24 }, function (_, i) {
                    return i < (0, dayjs_1.default)().hour() ? i : null;
                }).filter(function (v) { return v !== null; });
                var minutes_1 = Array.from({ length: 60 }, function (_, i) {
                    return i < (0, dayjs_1.default)().minute() ? i : null;
                }).filter(function (v) { return v !== null; });
                return {
                    disabledHours: function () { return hours_1; },
                    disabledMinutes: function (selectedHour) {
                        return selectedHour === (0, dayjs_1.default)().hour() ? minutes_1 : [];
                    },
                };
            }
        }
        else {
            if (current.isSame((0, dayjs_1.default)(), 'day')) {
                var hours_2 = Array.from({ length: 24 }, function (_, i) {
                    return i > (0, dayjs_1.default)().hour() ? i : null;
                }).filter(function (v) { return v !== null; });
                var minutes_2 = Array.from({ length: 60 }, function (_, i) {
                    return i > (0, dayjs_1.default)().minute() ? i : null;
                }).filter(function (v) { return v !== null; });
                return {
                    disabledHours: function () { return hours_2; },
                    disabledMinutes: function (selectedHour) {
                        return selectedHour === (0, dayjs_1.default)().hour() ? minutes_2 : [];
                    },
                };
            }
        }
        return {};
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, { theme: {
                    token: {
                        colorBgContainerDisabled: props.disabledColor || '',
                    },
                }, children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { id: props.id || '', disabledTime: props.isDateTime ? disabledTime : undefined, disabledDate: disabledDate, showTime: props.isDateTime, className: "".concat('apx-ui_date__picker', " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary', " ").concat(props.className), placeholder: props.placeholder, value: dateState, disabled: props.disabled, format: props.isDateTime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY', onChange: handleChange, status: props.required && props.errorText ? 'error' : '', picker: props.picker, allowClear: props.allowClear }) }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : ('')] }));
};
exports.ACDatePickerElement = ACDatePickerElement;
